export default "__VITE_ASSET__DHSHrgr$__"